
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import './globalStyle.css';
import CreateEventAdminPanel from './Components/AdminPanels/CreateEvent';
import EditEventAdminPanel from './Components/AdminPanels/EditEvent';
import PasswordReset from './Plateforme/Pages/PasswordReset';
import ResetPasswordConfirm from './Plateforme/Pages/ResetPasswordConfirm';
import * as api from './api';
import ScrollToTop from './utils/ScrollToTop';
import styled from 'styled-components'
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import Shortlists from './Components/AdminPanels/SD/Shortlists';
import EditShorlistPage from './Components/AdminPanels/SD/EditShorlistPage';
import FDCreateEventAdminPanel from './Components/AdminPanels/FDCreateEvent';
import FDEditEventAdminPanel from './Components/AdminPanels/FDEditEvent';
import FDAdmin from './Components/AdminPanels/FDAdmin';
import ModernFDProjetsWrapper from './Components/AdminPanels/ModernFDProjetsWrapper';
import FDFicheEntreprise from './Components/AdminPanels/FDFicheEntreprise';
import FDFicheProjet from './Components/AdminPanels/FDFicheProjet';
import FichePopBPage from './Components/AdminPanels/SD/FichePopBPage';
import Planning from './Components/AdminPanels/SD/Planning';
import FDFicheV2 from './Components/AdminPanels/FD1002023/FDFicheV2';
import FDFicheV2ProjetPage from './Components/AdminPanels/FD1002023/FDFicheV2ProjetPage';
import LoginRegisterIframe from './Plateforme/Pages/LoginRegisterIframe';
import Register from './Plateforme/Pages/Register';
import NavigationV2 from './Plateforme/Components/Navigation';
import AnnuaireV2 from './Plateforme/Pages/Annuaire';
import MyProfile from './Plateforme/Pages/MyProfile';
import MyCompany from './Plateforme/Pages/MyCompany';
import ProfileV2 from './Plateforme/Pages/Profile';
import Company from './Plateforme/Pages/Company';
import MyProject from './Plateforme/Pages/MyProject';
import MyPointsOfSale from './Plateforme/Pages/MyPointsOfSale';
import MyDashboard from './Plateforme/Pages/MyDashboard';
import Project from './Plateforme/Pages/Project';
import Section from './Plateforme/Atoms/Section';
import FooterV2 from './Plateforme/Components/Footer';
import Profiles from './Plateforme/Pages/Admin/Profiles';
import Companies from './Plateforme/Pages/Admin/Companies';
import Projects from './Plateforme/Pages/Admin/Projects';
import Events from './Plateforme/Pages/Events';
import EventsAdminPanel from './Components/AdminPanels/Events';
import CreateEventModern from './Plateforme/Pages/Admin/CreateEventModern';
import DesignEventDetails from './Plateforme/Pages/Admin/DesignEventDetails';
import LearnMoreEvent from './Plateforme/Pages/LearnMoreEvent';
import RegisterSDE24popA from './Plateforme/Pages/SDE24/RegisterSDE24popA';
import RegisterSDE24popB from './Plateforme/Pages/SDE24/RegisterSDE24popB';
import EditParticipation from './Plateforme/Pages/SDE24/EditParticipation';
import Candidatures from './Plateforme/Pages/SDE24/Candidatures';
import Thanks from './Plateforme/Components/SDE24/Parcours/Thanks';
import ThanksSDO from './Plateforme/Components/SDO24/Parcours/Thanks';
import RegisterSDO24popA from './Plateforme/Pages/SDO2024/RegisterSDO24popA';
import RegisterSDO24popB from './Plateforme/Pages/SDO2024/RegisterSDO24popB';
import MilkNewsletter2025 from './Plateforme/Pages/MilkNewsletter2025';
import Prescripteurs from './Plateforme/Pages/SDE24/Prescripteurs';
import RegisterSDE from './Plateforme/Pages/SDE24/RegisterSDE';
import CandidaturesNew from './Plateforme/Pages/SDE24/CandidaturesNew';
import SDO2026LandingPage from './Plateforme/Pages/SDO2026/SDO2026LandingPage';
import SDO2026AnnoncesPublic from './Plateforme/Pages/SDO2026/SDO2026AnnoncesPublic';
import SDOAccordConfidentialite from './Plateforme/Pages/SDO2026/SDOAccordConfidentialite';
import SDEAdmin from './Plateforme/Pages/Admin/SDEAdmin';
import SDEShortlistAdmin from './Plateforme/Pages/Admin/SDEShortlistAdmin';
import SDEPlanningAdmin from './Plateforme/Pages/Admin/SDEPlanningAdmin';
import GoogleAnalytics from './Components/GoogleAnalytics'; // Import the new component
import PageNotFound from './Plateforme/Pages/PageNotFound';
import Homepage from './Plateforme/Pages/Homepage';
import Apropos from './Plateforme/Pages/Apropos';
import Actualités from './Plateforme/Pages/Actualités';
import Forms from './Plateforme/Pages/Forms';
import Milan2026Form from './Plateforme/Pages/Milan2026Form';
import FD100ExpoDisponibiliteForm from './Plateforme/Pages/FD100ExpoDisponibiliteForm';
import FD100ExpoConfirmationForm from './Plateforme/Pages/FD100ExpoConfirmationForm';
import RegisterFD1002025 from './Plateforme/Pages/FD1002025/RegisterFD1002025';
import WorldMapSimple from './Plateforme/Pages/Worldmap/WorldmapSimple';
import EditParticipationFD100 from './Plateforme/Pages/FD1002025/EditParticipation';
import AdminUpload from './Plateforme/Pages/Worldmap/AdminUpload';
import WorldMapSimpleFramed from './Plateforme/Pages/Worldmap/WorldmapSimpleFramed';
import WorldmapAdminView from './Plateforme/Pages/Worldmap/WorldmapAdminView';
import ConfirmPayment from './Plateforme/Pages/ConfirmPayment';
import FDJury from './Plateforme/Pages/FD1002025/Jury';
import FD10025Winners from './Plateforme/Pages/FD1002025/FD10025Winners';
import FD100KVTest from './Plateforme/Pages/FD1002025/FD100KVTest';
import FD100KVLogoReview from './Plateforme/Pages/FD1002025/FD100KVLogoReview';
import FD100DefinitiveKVs from './Plateforme/Pages/FD1002025/FD100DefinitiveKVs';
import FD100SignupPage from './Plateforme/Pages/FD100SignupPage';
import InstitutionnelSignupPage from './Plateforme/Pages/InstitutionnelSignupPage';
import FD100ProjectSetupPage from './Plateforme/Pages/FD100ProjectSetupPage';
import FD100CompilationJury from './Plateforme/Pages/Admin/FD100CompilationJury';
import FD100ArchitectureRatings from './Plateforme/Pages/Admin/FD100ArchitectureRatings';
import FD100MentionContractRatings from './Plateforme/Pages/Admin/FD100MentionContractRatings';
import FD100ProjectsInCompetition from './Plateforme/Pages/Admin/FD100ProjectsInCompetition';
import FD100FinalSelection from './Plateforme/Pages/Admin/FD100FinalSelection';
import FDJuryProgress from './Plateforme/Pages/Admin/FDJuryProgress';
import { PaymentPopupV2 } from './Plateforme/Components/PaymentPopup';
import MyCandidatures from './Plateforme/Pages/MyCandidatures';
import MyWinningProjects from './Plateforme/Pages/MyWinningProjects';
import DocumentsASignerFD100 from './Plateforme/Pages/DocumentsASignerFD100';
import InformationsAValiderFD100 from './Plateforme/Pages/InformationsAValiderFD100';
import PartenairesView from './Plateforme/Pages/PartenairesView';
import PresseKitView from './Plateforme/Pages/PresseKitView';
import CommunicationKitPage from './Plateforme/Pages/CommunicationKitPage';
import PartenairesUploadLogo from './Plateforme/Pages/PartenairesUploadLogo';
import WebinairesArchive from './Plateforme/Pages/WebinairesArchive';
import ITWArchive from './Plateforme/Pages/ITWArchive';
import CahierDeStyle from './Plateforme/Pages/Admin/CahierDeStyle';
import FD100PressPage from './Plateforme/Pages/Admin/FD100Press';
import FD100SuiviLaureats from './Plateforme/Pages/Admin/FD100SuiviLaureats';
import FD100PastWinners from './Plateforme/Pages/Admin/FD100PastWinners';
import FD100EditEventSupabase from './Plateforme/Pages/Admin/FD100EditEventSupabase';
import FD100Partenaires from './Plateforme/Pages/Admin/FD100Partenaires';
import FD100Exposition from './Plateforme/Pages/Admin/FD100Exposition';
import FD100PastEditionGallery from './Plateforme/Pages/Admin/FD100PastEditionGallery';
import FD100EditionsExport from './Plateforme/Pages/Admin/FD100EditionsExport';
import FD100AllEditionsDashboard from './Plateforme/Pages/Admin/FD100AllEditionsDashboard';
import PresseFD100 from './Plateforme/Pages/PresseFD100';
import AnnuaireAdmin from './Plateforme/Pages/Admin/AnnuaireAdmin';
import { Toaster } from 'react-hot-toast';
import ActualitesCahierDeStyle from './Plateforme/Pages/ActualitesCahierDeStyle';
import FormSubmissionDetail from './Components/AdminPanels/FormSubmissionDetail';
import UserFormSubmissionDetail from './Plateforme/Pages/UserFormSubmissionDetail';
import TableauDemo from './Plateforme/Pages/Admin/TableauDemo';
import Monitoring from './Plateforme/Pages/Admin/Monitoring';
import RSVPFD100 from './Plateforme/Pages/RSVPFD100';
import RSVPTalkFD100 from './Plateforme/Pages/RSVPTalkFD100';
import FD100CeremonyRSVP from './Plateforme/Pages/Admin/FD100CeremonyRSVP';
import FD100TalkRSVP from './Plateforme/Pages/Admin/FD100TalkRSVP';
import FD100PrixDuPublic from './Plateforme/Pages/Admin/FD100PrixDuPublic';
import VoteFD100Page from './Plateforme/Pages/VoteFD100Page';
import VoteFD100ProjectPage from './Plateforme/Pages/VoteFD100ProjectPage';
import FD100Gallery from './Plateforme/Pages/FD100Gallery';
import FD100ExpoSuiviPiecesPublic from './Plateforme/Pages/FD100ExpoSuiviPiecesPublic';
import FD100ExpoFinalePublic from './Plateforme/Pages/FD100ExpoFinalePublic';
import FD100ExpoContratForm from './Plateforme/Pages/FD100ExpoContratForm';

require('dayjs/locale/fr')

const MainContainerV2 = styled.main`
  margin: auto;
  background-color: white;
  padding-left: 90px; /* 90px for the sidebar */
  min-height: 72vh;

  /* sidebar dissapears when width is less than 1000px or height is less than 660px */
  @media (max-width: 1000px) or (max-height: 660px) {
    padding-left: 0px;
  }
`

const V2 = (props) => {

  const [fullUser, setFullUser] = React.useState(null);
  const [fullUserLoading, setFullUserLoading] = React.useState(true);
  const {i18n} = useTranslation('common');
  dayjs.locale(i18n.language)
  //on route change, scroll to top
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  React.useEffect(() => {
    refreshUser()
  }, [props.user?.email]);

  function refreshUser(){
    setFullUserLoading(true);
    return api.GetCurrentUser().then((response) => {
      const userEmail = response.data.email;
      // console.log("response GetCurrentUser : ");
      // console.log(response.data);
      if(!userEmail) {
        setFullUser(null);
        setFullUserLoading(false);
        return null;
      };
      setFullUserLoading(true);
      return api.GetAllUserData({email : userEmail}).then((_response) => {
          // console.log("GetAllUserData result from App.js :");
          // console.log(_response.data);
          setFullUser(_response.data);
          setFullUserLoading(false);
          return _response.data; // Return the updated user data
      }).catch((error) => {
          console.log(error);
          setFullUser(null);
          setFullUserLoading(false);
          return null;
      });
    }).catch((error) => {
      setFullUser(null);
      setFullUserLoading(false);
      console.log(error);
      return null;
    });
  }

  return (
    <>
    <Toaster position="top-right" />
    <Routes>
      {/* Fullscreen WorldMap routes without navigation or container */}
      <Route path="worldmap" element={<WorldMapSimple/>} />
      <Route path="worldmapframed" element={<WorldMapSimpleFramed/>} />
      <Route path="worldmap-admin-view" element={<WorldmapAdminView />} />

      {/* Fullscreen public expo suivi pieces page (no nav/sidebar) */}
      <Route path="expo/suivi-pieces" element={<FD100ExpoSuiviPiecesPublic />} />
      <Route path="expo/finale" element={<FD100ExpoFinalePublic />} />

      {/* All other routes with normal layout */}
      <Route path="*" element={
        <>
          <NavigationV2 fullUser={fullUser} fullUserLoading={fullUserLoading} refreshUser={refreshUser}/>
          <ScrollToTop>
            <MainContainerV2>
              <Routes>
                <Route path="" element={<Homepage  fullUser={fullUser}/>}/>
                <Route path="login" element={<LoginRegisterIframe refreshUser={refreshUser}/>}/>
                <Route path="resetpassword" element={<Section className='padding'><PasswordReset/></Section>}/>
                <Route path="resetpasswordconfirm" element={<Section className='padding'><ResetPasswordConfirm/></Section>}/>
                <Route path="register" element={<Register refreshUser={refreshUser} />} />
                <Route path="fd100-signup" element={<FD100SignupPage refreshUser={refreshUser} />} />
                <Route path="inscription-institutionnel" element={<InstitutionnelSignupPage refreshUser={refreshUser} />} />
                <Route path="fd100-project-setup" element={<FD100ProjectSetupPage fullUser={fullUser} refreshUser={refreshUser} fullUserLoading={fullUserLoading} />} />
                <Route path="annuaire" element={<AnnuaireV2 fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements" element={<Events fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/learnmore" element={<Section className='padding'><LearnMoreEvent fullUser={fullUser} /></Section>}/>
                <Route path="evenements/joina" element={<RegisterSDE24popA fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/joinb" element={<RegisterSDE24popB fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/sdojoina" element={<RegisterSDO24popA fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/sdojoinb" element={<RegisterSDO24popB fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/editparticipation" element={<EditParticipation fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/sdebcandidature" element={<Candidatures fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/prescripteurs" element={<Prescripteurs fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/sde/register" element={<RegisterSDE fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/sde/candidatures" element={<CandidaturesNew fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/sdo/register" element={<RegisterSDE fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/sdo/candidatures" element={<CandidaturesNew fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="evenements/sdo2026" element={<SDO2026LandingPage fullUser={fullUser} fullUserLoading={fullUserLoading} refreshUser={refreshUser}/>}/>
                <Route path="evenements/sdo2026/annonces-createurs-6a612eb48d" element={<SDO2026AnnoncesPublic />}/>
                <Route path="evenements/sdo/accord-confidentialite" element={<SDOAccordConfidentialite />}/>
                <Route path="mydashboard" element={<MyDashboard fullUser={fullUser} refreshUser={refreshUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="myprofile" element={<MyProfile fullUser={fullUser} refreshUser={refreshUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="mycandidatures" element={<MyCandidatures fullUser={fullUser} refreshUser={refreshUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="mywinningprojects" element={<MyWinningProjects fullUser={fullUser} refreshUser={refreshUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="mywinningprojects/documents-a-signer" element={<DocumentsASignerFD100 fullUser={fullUser} refreshUser={refreshUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="mywinningprojects/informations-a-valider" element={<InformationsAValiderFD100 fullUser={fullUser} refreshUser={refreshUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="partenaires" element={<PartenairesView />}/>
                <Route path="presse-kit" element={<PresseKitView />}/>
                <Route path="communication-kit" element={<CommunicationKitPage />}/>
                <Route path="partenaires/upload-logo" element={<PartenairesUploadLogo />}/>
                <Route path="mycandidatures/milan2026/:id" element={<UserFormSubmissionDetail fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="webinaires" element={<WebinairesArchive/>}/>
                <Route path="interviews" element={<ITWArchive/>}/>
                <Route path="presse/fd100/:eventId" element={<PresseFD100 />}/>
                <Route path="annuaireadmin" element={<AnnuaireAdmin fullUser={fullUser} fullUserLoading={fullUserLoading} refreshUser={refreshUser}/>}/>

                <Route path="cahiersdestyle" element={<ActualitesCahierDeStyle fullUser={fullUser} fullUserLoading={fullUserLoading} refreshUser={refreshUser}/>}/>


                <Route path="mycompany" element={<MyCompany fullUser={fullUser} refreshUser={refreshUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="myproject" element={<MyProject fullUser={fullUser} refreshUser={refreshUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="mypointofsale" element={<MyPointsOfSale fullUser={fullUser} refreshUser={refreshUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="profile" element={<ProfileV2 fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="company" element={<Company fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="project" element={<Project fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/profiles" element={<Profiles fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/companies" element={<Companies fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/projects" element={<Projects fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/events" element={<Section className='padding'><EventsAdminPanel fullUser={fullUser} fullUserLoading={fullUserLoading} /></Section>}/>
                <Route path="admin/events/createevent" element={<Section className='padding'><CreateEventAdminPanel /></Section>}/>
                <Route path="admin/events/createevent-modern" element={<Section className='padding'><CreateEventModern /></Section>}/>
                <Route path="admin/events/design-details" element={<Section className='padding'><DesignEventDetails /></Section>}/>
                <Route path="admin/events/editevent" element={<Section className='padding'><EditEventAdminPanel /></Section>}/>
                <Route path="admin/events/shortlists" element={<Section className='padding' style={{padding:"20px 100px"}}><Shortlists /></Section>}/>
                <Route path="admin/events/ficheadminpopb" element={<Section className='padding'><FichePopBPage /></Section>}/>
                <Route path="admin/events/editshortlists" element={<Section className='padding'><EditShorlistPage /></Section>}/>
                <Route path="admin/events/planning" element={<Planning/>}/>
                <Route path="evenements/fd100join" element={<RegisterFD1002025 fullUser={fullUser} fullUserLoading={fullUserLoading} refreshUser={refreshUser}/>}/>
                <Route path="evenements/fd100editparticipation" element={<EditParticipationFD100 fullUser={fullUser}/>}/>
                <Route path="evenements/milan2026" element={<Milan2026Form fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/events/fdadmin" element={<Section className='padding'><FDAdmin/></Section>}/>
                <Route path="admin/events/fd100projects-modern" element={<Section className='padding'><ModernFDProjetsWrapper/></Section>}/>
                <Route path="admin/events/fdcompilationjury" element={<Section className='padding'><FD100CompilationJury/></Section>}/>
                <Route path="admin/events/fd100architectureratings" element={<Section className='padding'><FD100ArchitectureRatings/></Section>}/>
                <Route path="admin/events/fd100mentioncontractratings" element={<Section className='padding'><FD100MentionContractRatings/></Section>}/>
                <Route path="admin/events/fd100projects" element={<Section className='padding'><FD100ProjectsInCompetition/></Section>}/>
                <Route path="admin/events/fd100finalselection" element={<Section className='padding'><FD100FinalSelection/></Section>}/>
                <Route path="admin/events/fdjuryprogress" element={<Section className='padding'><FDJuryProgress/></Section>}/>
                <Route path="admin/events/fdficheentreprise" element={<Section className='padding'><FDFicheEntreprise/></Section>}/>
                <Route path="admin/events/fdficheprojet" element={<FDFicheProjet/>}/>
                <Route path="admin/events/fdcreateevent" element={<Section className='padding'><FDCreateEventAdminPanel/></Section>}/>
                <Route path="admin/events/fdeditevent" element={<Section className='padding'><FDEditEventAdminPanel/></Section>}/>
                <Route path="admin/events/fd100-press" element={<Section className='padding'><FD100PressPage /></Section>}/>
                <Route path="admin/events/fd100-suivi-laureats" element={<FD100SuiviLaureats />}/>
                <Route path="admin/events/fd100-past-winners" element={<FD100PastWinners />}/>
                <Route path="admin/events/fd100-edit-supabase" element={<FD100EditEventSupabase />}/>
                <Route path="admin/events/fd100-partenaires" element={<FD100Partenaires />}/>
                <Route path="admin/events/fd100-exposition" element={<FD100Exposition />}/>
                <Route path="admin/events/fd100-past-edition-gallery" element={<Section className='padding'><FD100PastEditionGallery /></Section>}/>
                <Route path="admin/events/fd100-editions-export" element={<FD100EditionsExport />}/>
                <Route path="admin/events/fd100-all-editions" element={<FD100AllEditionsDashboard />}/>
                <Route path="admin/events/sde" element={<SDEAdmin fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/events/sde/shortlist" element={<SDEShortlistAdmin fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/events/sde/planning" element={<SDEPlanningAdmin fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/events/sdo" element={<SDEAdmin fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/events/sdo/shortlist" element={<SDEShortlistAdmin fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/events/sdo/planning" element={<SDEPlanningAdmin fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/forms/submission/:id" element={<FormSubmissionDetail />}/>
                <Route path="tableau-demo" element={<TableauDemo fullUser={fullUser} />}/>
                <Route path="admin/cdc" element={<CahierDeStyle/>}/>
                <Route path="admin/monitoring" element={<Monitoring fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/events/fd100-ceremony-rsvp" element={<FD100CeremonyRSVP fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/events/fd100-talk-rsvp" element={<FD100TalkRSVP fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="admin/events/fd100-prix-du-public" element={<FD100PrixDuPublic fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="fdjury" element={<Section className='padding'><FDJury fullUser={fullUser} fullUserLoading={fullUserLoading}/></Section>}/>
                <Route path="fd100/2025/selection-finale" element={<Section className='padding'><FD10025Winners /></Section>}/>
                <Route path="fd100kvtest" element={<Section className='padding'><FD100KVTest /></Section>}/>
                <Route path="fd100kvlogoreview" element={<Section className='padding'><FD100KVLogoReview /></Section>}/>
                <Route path="definitiveKVs" element={<Section className='padding'><FD100DefinitiveKVs /></Section>}/>
                <Route path="thanks" element={<Thanks/>}/>
                <Route path="thankssdo" element={<ThanksSDO/>}/>
                <Route path="homepage" element={<Homepage  fullUser={fullUser}/>}/>
                <Route path="fd100" element={<FD100Gallery fullUser={fullUser}/>}/>
                <Route path="apropos" element={<Apropos/>}/>
                <Route path="actualités" element={<Actualités/>}/>
                <Route path="forms" element={<Forms/>}/>
                <Route path="forms/milan-2026" element={<Milan2026Form fullUser={fullUser} fullUserLoading={fullUserLoading}/>}/>
                <Route path="forms/fd100-expo-disponibilite" element={<FD100ExpoDisponibiliteForm />}/>
                <Route path="forms/fd100-expo-confirmation" element={<FD100ExpoConfirmationForm />}/>
                <Route path="forms/fd100-expo-contrat" element={<FD100ExpoContratForm />}/>
                <Route path="admin-worldmap" element={<AdminUpload/>}/>
                <Route path="vote/fd100" element={<VoteFD100Page/>}/>
                <Route path="vote/fd100/preview" element={<VoteFD100Page preview/>}/>
                <Route path="vote/fd100/:projectId" element={<VoteFD100ProjectPage/>}/>
                <Route path="rsvp/fd100" element={<RSVPFD100/>}/>
                <Route path="rsvp/talk" element={<RSVPTalkFD100/>}/>
                <Route path="milk-newsletter-2025" element={<MilkNewsletter2025/>}/>
                <Route path="confirmpayment" element={<Section className='padding centered'><ConfirmPayment fullUser={fullUser} fullUserLoading={fullUserLoading} refreshUser={refreshUser}/></Section>}/>
                <Route path="test_nouveau_paiement" element={<Section className='padding'><PaymentPopupV2/></Section>}/>
                <Route path='*' element={<PageNotFound />} />
              </Routes>
              <FooterV2/>
            </MainContainerV2>
          </ScrollToTop>
        </>
      } />
    </Routes>
  </>
)
};


const App = () => {
  
  const [userLoggedIn, setUserLoggedIn] = React.useState(false);
  const [user, setUser] = React.useState(null);
  const trackingId = 'G-E838JRFN4W';

  React.useEffect(() => {
    const handleUnhandledRejection = (event) => {
      const errMsg = `Unhandled Rejection: ${event.reason}`;
      api.LogFront(errMsg).catch(console.error);
    };

    const handleError = ({message, filename, lineno, colno, error}) => {
      console.log('Window Error:', message, filename, lineno, colno, error);
      const errorMessages = error?.message || message || error?.toString() || 'No error message';
      const errMsg = `Window Error: ${errorMessages} at ${filename}:${lineno}:${colno}, while visiting ${window.location.href}`;
      console.log(errMsg);
      api.LogFront(errMsg).catch(console.error);
      return true; // Prevent default handler
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  React.useEffect(() => {
    api.GetCurrentUser().then((response) => {
      // console.log("response GetCurrentUser : ");
      // console.log(response);
      setUserLoggedIn(true);
      setUser(response.data);
    }).catch((error) => {
      setUserLoggedIn(false);
      setUser(null);
      console.log(error);
    });
  }, []);

  React.useEffect(() => {
    api.GetCurrentUser().then((response) => {
      // console.log("response GetCurrentUser : ");
      // console.log(response);
      setUser(response.data);
    }).catch((error) => {
      setUser(null);
      console.log(error);
    });
  }, [userLoggedIn]);

  function Redirect() {
    const location = useLocation();
    // Extract the path after "/_/"
    const newPath = location.pathname.replace(/^\/_/, "");
    // Reconstruct the full URL with search and hash
    const fullPath = `${newPath}${location.search}${location.hash}`;
    return <Navigate to={fullPath} replace />;
  }

  return (
    <BrowserRouter>
    <GoogleAnalytics trackingId={trackingId} />
      <Routes>
        {/* redirect '/_/anyhting' to '/anyhting' */}
        <Route path="/_/*" element={<Redirect />} />
        <Route path="/*" element={<V2 userLoggedIn={userLoggedIn} setUserLoggedIn={setUserLoggedIn} user={user} />} />
        <Route path="fdfichev2" element={<FDFicheV2/>}/>
        <Route path="fdfichev2proj" element={<FDFicheV2ProjetPage/>}/>
        {/* Routes plateforme */}
        <Route path="loginregisteriframe" element={<LoginRegisterIframe setUserLoggedIn={setUserLoggedIn}/>}/>
      </Routes>
    </BrowserRouter>
  );
};

export default App;